import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch`}</h2>
    <p>{`Email me at `}<a parentName="p" {...{
        "href": "mailto:eric.josh.grossman@gmail.com"
      }}>{`eric.josh.grossman@gmail.com`}</a>{` or find me on other platforms: `}<a parentName="p" {...{
        "href": "https://www.github.com/11grossmane"
      }}>{`Github`}</a>{` & `}<a parentName="p" {...{
        "href": "http://www.linkedin.com/in/eric-josh-grossman"
      }}>{`LinkedIn`}</a></p>
    <p>{`Podcast Links: `}<a parentName="p" {...{
        "href": "https://open.spotify.com/show/2y5sgsSwcGRP6FgyYAHGl8?si=zSHui5fCQkunJq8Lb5XgAw"
      }}>{`Spotify`}</a>{` & `}<a parentName="p" {...{
        "href": "https://podcasts.apple.com/us/podcast/story-tadpole/id1368620124"
      }}>{`Apple Podcasts`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      